<table class="ir-plugin-table" style="margin-bottom: 10px" *ngFor="let item of dates">
  <tr *ngIf="item.Label">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ item.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-installationreceived_comment ir-ph1"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="item.DateValue">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationdate.date' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ item.DateValue | formatDate }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="item.Milestone">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationdate.milestone' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ item.Milestone }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="item.NumberOfDaysAfter">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationdate.number-of-days-after' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ item.NumberOfDaysAfter }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="item.Comment">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationdate.comments' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-installationreceived_comment ir-ph1" [innerHtml]="item.Comment"></span>
      </p>
    </td>
  </tr>
</table>
